// extracted by mini-css-extract-plugin
export default {"container":"WD-z","modal":"XD-z","dimensions":"YD-z","brandName":"ZD-z","productName":"_D-z","labelValue":"aE-z","recipientEmail":"bE-z","recommendedFit":"cE-z","hiddenField":"dE-z"};